import React, { createContext, useContext, useState, ReactNode, useMemo } from "react";
import { Config } from "@/types/Config";

interface ConfigContextType {
  config: Config;
  setConfig: (config: Config) => void;
}

const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

interface ConfigProviderProps {
  children: ReactNode;
  initialConfig: Config;
}

export const ClientConfigProvider = ({
  children,
  initialConfig,
}: ConfigProviderProps) => {
  const [config, setConfig] = useState<Config>(initialConfig);

  const value = useMemo(() => ({ config, setConfig }), [config]);


  return (
    <ConfigContext.Provider value={value}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error("useConfig must be used within a ConfigProvider");
  }
  return context;
};
